import React, { useEffect, useState } from "react"
import instacartDiscountIcon from "../../../../images/instacart_discount_icon.svg"
import phoneIcon from "../../../../images/phone-icon.svg"
import calendarIcon from "../../../../images/calendar-icon.svg"
import { connect } from "react-redux"
import { Button, Divider, Image, Modal } from "semantic-ui-react"
import { routerPaths } from "../../../../v1/constants/paths"
import { Link, Redirect } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { isDesktop } from "react-device-detect"
import LoadingComponent from "../../../../v1/components/LoadingComponent"
import { createOrder, updateOrder } from "../../../../v1/actions/orders"
import {
  gaJSON,
  logPurchase,
  orderBookedEvents,
  trackFirebaseAnalytics
} from "../../../../shared_component/utils/googleAnalyticsHelpers"
import PaymentMethod from "../../../../v1/components/PaymentMethods/PaymentMethod"
import caShortLogo from "../../../../images/ca-orange-short.svg"
import CloseIcon from "../../../../images/close-icon.svg"
import AffirmLogo from "../../../../images/affirm-logo.svg"
import { INSTACART, INSTACART_CANADA } from "../../../../v1/constants/affiliations"
import ReviewServices from "./ReviewServices"
import AddPaymentDetails from "../AddPaymentDetails"
import { getUpdatedCart } from "../../../../v1/helpers/orderHelpers"
import InfoIcon from "../../../../images/info-Icon.svg"

const ReviewRequest = ({
  cart,
  vehicle,
  activeVehicle,
  createOrder,
  updateOrder,
  t,
  user,
  braintreePaymentMethods,
  order
}) => {
  const [orderId, setOrderId] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [customerNote, setCustomerNote] = useState("")
  const isInstacartUser = [INSTACART, INSTACART_CANADA].includes(
    user?.affiliation?.root_reference_id
  )
  const defaultPaymentMethod = braintreePaymentMethods.find((method) => method.isdefault)

  const handleCustomerNote = (e) => {
    setCustomerNote(e.target.value)
  }
  const toggleModal = () => {
    setOpenModal(true)
  }

  useEffect(() => {
    trackFirebaseAnalytics({
      event: gaJSON.checkout_start,
      params: {
        cart_value: cart.estimated_total || 0,
        service_count: cart.order_services.length || 0,
        returning_user: user.total_shop_orders > 0 ? "true" : "false"
      }
    })
  }, [])

  const onSubmit = async () => {
    setIsSubmitting(true)
    try {
      const response = order
        ? await updateOrder(cart, order)
        : await createOrder(cart.id, null, customerNote)
      const orderId = response.result ? response.result.id : response
      if (orderId) {
        setOrderId(orderId)
        logPurchase(response.result.currency.toUpperCase(), response.result.total)
        await orderBookedEvents({ response, orderId, activeVehicle })
      }
      trackFirebaseAnalytics({
        event: gaJSON.checkout_complete,
        params: {
          order_id: orderId,
          total_amount: response.result.total,
          payment_method_type: response.result.payment_type
        }
      })
      setIsSubmitting(false)
    } catch (error) {
      setIsSubmitting(false)
      trackFirebaseAnalytics({
        event: gaJSON.EtoB_confirm_service_request_error
      })
    }
  }

  let discountLogo = caShortLogo
  if (isInstacartUser) {
    discountLogo = instacartDiscountIcon
  }

  return (
    <>
      {orderId && <Redirect to={`/appointment-confirm/${orderId}`} />}
      {cart && cart.shop ? (
        <div className="review-request-container">
          {user &&
            user.country !== "ca" &&
            cart &&
            !cart.any_order_service_lacks_price &&
            cart.promotions &&
            cart.promotions.length > 0 && (
              <>
                <div className="discount-banner">
                  <div className="discount-banner-text">
                    <img className="discount-icon-review" src={discountLogo} />
                    {cart.promotions[0].discount}% {t("oilChangeDiscountApplied")}
                  </div>
                </div>
                <div className="spacer-20" />
              </>
            )}
          <div className="heading-size-18" style={{ fontWeight: 700 }}>
            {t("appointmentDetails")}
          </div>
          <div className="spacer-10" />
          <div className="row-space-between">
            <div className="shop-name">{cart.shop ? cart.shop.name : ""}</div>
            <Link
              className="link-text"
              to={routerPaths.shopSelection}
              onClick={() => {
                trackFirebaseAnalytics({
                  event: gaJSON.EtoB_change_selected_shop_review_page
                })
              }}
            >
              {t("change")}
            </Link>
          </div>
          <div className="body-text-16" style={{ color: "#616161" }}>
            {cart.shop ? cart.shop.address_line1 : ""}
          </div>
          <div className="body-text-16" style={{ color: "#616161" }}>
            {cart.shop ? `${cart.shop?.city}, ${cart.shop?.state} - ${cart.shop?.zip}` : ""}
          </div>
          {cart.shop && cart.shop.main_phone_number && (
            <a
              href={isDesktop ? null : "tel:" + cart.shop.main_phone_number}
              className="row-flex-start"
            >
              <img src={phoneIcon} style={{ paddingRight: "5px", height: "16px", width: "16px" }} />
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: 400
                }}
              >
                {cart.shop.main_phone_number}
              </div>
            </a>
          )}
          <div className="spacer-10" />
          <div className="row-space-between">
            <div className="row-flex-start" style={{ color: "#B83614" }}>
              <img
                src={calendarIcon}
                style={{ paddingRight: "5px", height: "16px", width: "16px" }}
              />
              <div style={{ fontWeight: 500, fontSize: "16px" }}>
                {cart.appointment_date_pretty.split(", ")[1]}
                {", "}
                {cart.appointment_date_pretty.split(", ")[2]} |{" "}
                {cart.is_walk_in || false ? "Walk-in only" : cart.appointment_time_pretty}
              </div>
            </div>
            <Link
              className="link-text"
              to={routerPaths.appointment}
              onClick={() => {
                trackFirebaseAnalytics({
                  event: gaJSON.EtoB_change_appointment_review_page
                })
              }}
            >
              {t("change")}
            </Link>
          </div>
          <div className="spacer-10" />
          <div className="row-flex-start" style={{ fontWeight: 400, fontSize: "14px" }}>
            {vehicle.year || ""} {vehicle.make || ""} {vehicle.model || ""}
          </div>

          <Divider />
          <ReviewServices handleCustomerNote={handleCustomerNote} customerNote={customerNote} />
          <Divider />

          <div className="payment-method-review">
            <div className="row-space-between">
              <span className="payment-header">Payment method</span>{" "}
              <span onClick={() => setOpenModal(true)} className="change-payment">
                Change
              </span>
            </div>
            <div className="spacer-20" />
            {cart.payment_type !== "affirm" &&
              defaultPaymentMethod &&
              defaultPaymentMethod.token && (
                <PaymentMethod
                  key={defaultPaymentMethod.token}
                  paymentMethod={defaultPaymentMethod}
                  hideDelete={true}
                  hideSetDefault={true}
                />
              )}
            {cart.payment_type == "affirm" && (
              <div>
                <Image src={AffirmLogo} alt="Affirm-Logo" />
              </div>
            )}
          </div>
          <div className="spacer-20" />
          <div className="priced-at-shop-banner teal-color">
            <img className="discount-icon-review" src={InfoIcon} />
            <div className="text-block">
              <span>{t("onlyChargedWhen")} </span>
            </div>
          </div>
          <div className="action_button">
            <Button
              fluid
              loading={isSubmitting}
              onClick={onSubmit}
              disabled={
                (!cart.shop && !cart.appointment_date_pretty) ||
                isSubmitting ||
                cart.order_services.length == 0
              }
              className="primary-button"
            >
              {t("confirmServiceRequest")}
            </Button>
          </div>
        </div>
      ) : (
        <LoadingComponent />
      )}

      <Modal
        className="add-vehicle-modal payment-model"
        onClose={() => setOpenModal(false)}
        onOpen={() => setOpenModal(true)}
        open={openModal}
      >
        <div className="add-vehicle-header">
          <p>Choose your payment method</p>
          <p onClick={() => setOpenModal(false)}>
            <Image src={CloseIcon} alt="close-icon" />
          </p>
        </div>
        <div className="add-payment-content">
          <AddPaymentDetails asModal={true} closeModalHandler={() => setOpenModal(false)} />
        </div>
      </Modal>
    </>
  )
}

function mapStateToProps(state, props) {
  const user = state.user
  let cart
  const braintreePaymentMethods = Array.isArray(state?.paymentMethods?.braintreePaymentMethods)
    ? state.paymentMethods.braintreePaymentMethods.filter((method) => method?.type !== "ach")
    : []
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)
  const order =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)
  let updatedCartData = getUpdatedCart(user, order, props)
  if (updatedCartData) {
    cart = updatedCartData.cart
  } else {
    cart = user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
  }

  return {
    braintreePaymentMethods: braintreePaymentMethods,
    user: state.user,
    cart: cart,
    vehicle: activeVehicle,
    activeVehicle: activeVehicle,
    order
  }
}

export default connect(mapStateToProps, {
  createOrder,
  updateOrder
})(withTranslation("serviceRequest")(ReviewRequest))
